import React, { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = { withCredentials: true };

export default function CustomerAuthPage() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user.role === "customer") return <Navigate to="/cuenta" replace />;

  const doLogin = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/customer/login`, { email, password }, cfg);
      await refresh?.();
      toast.success("¡Bienvenida de nuevo!");
      nav("/cuenta");
    } catch { toast.error("Credenciales inválidas"); }
    setBusy(false);
  };

  const doRegister = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/customer/register`, { email, password, name }, cfg);
      await refresh?.();
      toast.success(`¡Bienvenido, ${name}!`);
      nav("/cuenta");
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo crear la cuenta");
    }
    setBusy(false);
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16">
      <p className="eyebrow mb-3">Área de clientes</p>
      <h1 className="font-serif text-4xl text-[color:var(--brand-primary)] font-light">Tu <span className="italic text-[color:var(--brand-terracotta)]">cuenta</span></h1>
      <Tabs defaultValue="login" className="mt-8">
        <TabsList className="grid grid-cols-2 bg-[color:var(--brand-bg-alt)] w-full">
          <TabsTrigger value="login" data-testid="tab-login">Entrar</TabsTrigger>
          <TabsTrigger value="register" data-testid="tab-register">Crear cuenta</TabsTrigger>
        </TabsList>
        <TabsContent value="login" className="mt-6">
          <form onSubmit={doLogin} className="space-y-3">
            <Input data-testid="cust-login-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            <Input data-testid="cust-login-password" type="password" required placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} />
            <Button data-testid="cust-login-submit" type="submit" disabled={busy} className="w-full bg-[color:var(--brand-primary)] hover:bg-black text-white rounded-md py-5">
              {busy ? "…" : "Entrar"}
            </Button>
          </form>
        </TabsContent>
        <TabsContent value="register" className="mt-6">
          <form onSubmit={doRegister} className="space-y-3">
            <Input data-testid="cust-reg-name" required placeholder="Tu nombre" value={name} onChange={(e) => setName(e.target.value)} />
            <Input data-testid="cust-reg-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            <Input data-testid="cust-reg-password" type="password" required minLength={8} placeholder="Contraseña (mín. 8)" value={password} onChange={(e) => setPassword(e.target.value)} />
            <Button data-testid="cust-reg-submit" type="submit" disabled={busy} className="w-full bg-[color:var(--brand-primary)] hover:bg-black text-white rounded-md py-5">
              {busy ? "…" : "Crear cuenta"}
            </Button>
          </form>
        </TabsContent>
      </Tabs>
      <p className="text-xs text-[color:var(--brand-neutral)]/60 mt-6 text-center">
        <Link to="/cuenta/recuperar" className="underline">¿Olvidaste tu contraseña?</Link> · Al crear cuenta aceptas la <Link to="/privacidad" className="underline">política de privacidad</Link>.
      </p>
    </div>
  );
}
